import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GlobalMessageService, GlobalMessageType, RoutingService } from '@spartacus/core';
import { Observable, take } from 'rxjs';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';

@Component({
  selector: 'app-saved-carts-list-delete-modal',
  templateUrl: './saved-carts-list-delete-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SavedCartsListDeleteModalComponent implements OnInit {
  cartId: string;
  cartName: string;
  isSavedCartDetails: boolean;
  deleteInProgress = false;

  activeLanguage$: Observable<string> = this.languageService.getActive();

  constructor(
    protected modalService: StandardModalService,
    private saveCartService: CartExtendService,
    private componentService: ComponentService,
    private messageService: GlobalMessageService,
    private routing: RoutingService,
    private languageService: ShimanoLanguageService,
    private cdr: ChangeDetectorRef
  ) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res) => {
        this.cartId = res.cartId;
        this.cartName = res.cartName;
        this.isSavedCartDetails = res.isSavedCartDetails;
      });
  }

  ngOnInit() {}

  onDeleteSavedCart() {
    this.deleteInProgress = true;
    this.saveCartService.deleteSavedCart(this.cartId).subscribe({
      next: (data) => {
        if (typeof data !== 'undefined') {
          this.showGlobalMessage(
            'cart.deleteCartSuccessMessage',
            this.cartName,
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );
        }
        if (this.isSavedCartDetails) {
          this.routing.goByUrl('/saved-cart');
        } else {
          this.componentService.setSavedCartsListRefresh(true);
        }
        this.deleteInProgress = false;
        this.closeModal();
      },
      error: (error) => {
        if (error && error !== null) {
          const err = error.error.errors[0];
          if (err.type === 'CartError') {
            this.showGlobalMessage('httpHandlers.cartNotFound', null, GlobalMessageType.MSG_TYPE_ERROR);
          }
        }
        this.deleteInProgress = false;
        this.closeModal();
        this.cdr.detectChanges();
      },
    });
  }

  closeModal(info?: any) {
    this.modalService.closeDialog(info);
  }

  private showGlobalMessage(text: string, param: string, messageType: GlobalMessageType) {
    this.messageService.add({ key: text, params: { cartName: param } }, messageType);
    const element: HTMLElement = document.getElementsByClassName('BottomHeaderSlot')[0] as HTMLElement;
    element.scrollIntoView();
  }
}
